export class MBPError {
    statusCode?: number;
    validationErrorCode?: number;
    validationMessage?: string;
    handled?: boolean;
    logError?: boolean;
    originalError?: unknown;
}

/** Type guard narrowing an unknown thrown value to `MBPError`. */
export function isMbpError(error: unknown): error is MBPError {
  return error instanceof MBPError;
}

/** Normalizes any thrown value to an `MBPError`; non-MBP errors are wrapped and kept as `originalError`. */
export function toMbpError(error: unknown): MBPError {
  if (isMbpError(error)) {
    return error;
  }

  const mbpError = new MBPError();
  mbpError.originalError = error;
  return mbpError;
}
